import React, { useState } from 'react';
import { Paper, Tabs, Tab, TabPanel } from '@kambi/spark';

import classes from '../../../../App.module.css';
import CodeBlock from 'components/layout/code-block/CodeBlock';
import {
    betBuilders,
    betOffers,
    hasSelectedTeaser,
    selectedOutcomes,
    selectedReward,
    selectedTab,
    stakes,
} from './jsonExamples';

const GetPotentialPayoutTabs = () => {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.Tabs}>
            <Paper>
                <Tabs
                    kind="inverted"
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <Tab label="BetBuilders" />
                    <Tab label="betOffers" />
                    <Tab label="hasSelectedTeaser" />
                    <Tab label="selectedOutcomes" />
                    <Tab label="selectedReward" />
                    <Tab label="selectedTab" />
                    <Tab label="stakes" />
                </Tabs>
            </Paper>
            <TabPanel index={0} value={value} className={classes.TabPanel}>
                <p>
                    <strong>BetBuilders</strong> data should be sent to the
                    helper when the selectedTab is <strong>Combination</strong>.
                    The betBuilders are in the end, used in the{' '}
                    <strong>getTotalOdds</strong> helper to calculate total odds
                    consisted of betBuilder and regular outcome odds.
                </p>
                <p>
                    <strong>BetBuilder Type</strong>:
                </p>
                <ul>
                    <li>
                        selectedOdds:
                        <ul>
                            <li>decimal: number; </li>
                            <li>american: string; // optional</li>
                            <li>fractional: string; // optional</li>
                        </ul>
                    </li>
                    <li>
                        selectedOutcomeIds:number [] // array of outcome id's.
                        E.g.: [124534343, 554435433, 556547657]
                    </li>
                </ul>
                <CodeBlock
                    title={betBuilders.title}
                    expectedOutput={betBuilders.expectedOutput}
                    initialDisplayedCode={betBuilders.initialDisplayedCode}
                    moreCode={betBuilders.moreCode}
                />
            </TabPanel>
            <TabPanel index={1} value={value} className={classes.TabPanel}>
                <p>
                    <strong>BetOffers</strong> payload info is only used in case
                    of an <strong>stake.eachWaySelected</strong>
                </p>
                <p>
                    <strong>BetOffers type</strong>
                </p>
                <ul>
                    <li>
                        eachWay
                        <ul>
                            <li>fractionMilli: number;</li>
                        </ul>
                    </li>
                    <li>id: number // betOfferId</li>
                </ul>
                <CodeBlock
                    title={betOffers.title}
                    expectedOutput={betOffers.expectedOutput}
                    initialDisplayedCode={betOffers.initialDisplayedCode}
                    moreCode={betOffers.moreCode}
                />
            </TabPanel>
            <TabPanel index={2} value={value} className={classes.TabPanel}>
                <p>
                    <strong>hasSelectedTeaser</strong> is a boolean property.
                    When it's set to true in the payload, we use the stake that
                    has type teaser to calculate the potential payout.
                </p>
                <p>
                    This value is considered only when selectedTab is
                    "combination". Check the different output when changing
                    <strong> hasSelectedTeaser</strong> true/false value
                </p>
                <CodeBlock
                    title={hasSelectedTeaser.title}
                    expectedOutput={hasSelectedTeaser.expectedOutput}
                    initialDisplayedCode={
                        hasSelectedTeaser.initialDisplayedCode
                    }
                    moreCode={hasSelectedTeaser.moreCode}
                />
            </TabPanel>
            <TabPanel index={3} value={value} className={classes.TabPanel}>
                <p>
                    <strong>selectedOutcomes</strong> payload key should contain
                    all selected outcomes in betslip.
                </p>
                <p>
                    <strong>selectedOutcomes</strong> types:
                </p>
                <ul>
                    <li>id: number | string</li>
                    <li>odds: number</li>
                    <li>
                        nrOfPermutations: number // required for multiPosition
                        outcomes
                    </li>
                    <li>
                        betOfferId: number // required only when there is
                        eachWay involved (see betOffer explanation)
                    </li>
                </ul>
                <CodeBlock
                    title={selectedOutcomes.title}
                    expectedOutput={selectedOutcomes.expectedOutput}
                    initialDisplayedCode={selectedOutcomes.initialDisplayedCode}
                    moreCode={selectedOutcomes.moreCode}
                />
            </TabPanel>
            <TabPanel index={4} value={value} className={classes.TabPanel}>
                <p>
                    <strong>selectedReward</strong> contains info about the
                    betslip selected reward.{' '}
                    <u>The information about the rewards should be in pairs</u>:
                    (isOddsBoost & boostedOdds & outcomeIds - to know for which
                    outcome to add the boosted odds value), (isProfitBoost &
                    boostPercentage), (isFreeBet & freeBetAmount)
                </p>
                <p>
                    <strong>selectedReward</strong> types. None of the
                    properties below are required
                </p>
                <ul>
                    <li>isOddsBoost: boolean</li>
                    <li>boostedOdds: number</li>
                    <li>
                        outcomeIds: (number | string)[] // array of outcomeId's
                    </li>
                    <li>isProfitBoost: boolean</li>
                    <li>boostPercentage: number</li>
                    <li>isFreeBet: boolean</li>
                    <li>freeBetAmount: number</li>
                </ul>
                <CodeBlock
                    title={selectedReward.title}
                    expectedOutput={selectedReward.expectedOutput}
                    initialDisplayedCode={selectedReward.initialDisplayedCode}
                    moreCode={selectedReward.moreCode}
                />
            </TabPanel>
            <TabPanel index={5} value={value} className={classes.TabPanel}>
                <p>
                    <strong>selectedTab</strong> reffers to betslip selected
                    tab. It can be <strong>single</strong> or{' '}
                    <strong>combination</strong>
                </p>
                <p>
                    Depending on the value of selectedTab, the potentialPayout
                    use different ways of calculating the output. E.g.: switch
                    from 'single' to 'combination' for <i>selectedTab</i> in the
                    code snipped below and see the expected result. Different
                    stake are used to calculate potential payout.
                </p>
                <CodeBlock
                    title={selectedTab.title}
                    expectedOutput={selectedTab.expectedOutput}
                    initialDisplayedCode={selectedTab.initialDisplayedCode}
                    moreCode={selectedTab.moreCode}
                />
            </TabPanel>
            <TabPanel index={6} value={value} className={classes.TabPanel}>
                <p>
                    The <strong>stakes</strong> object contains info about
                    stakes from all betslip tabs: single, multiple, system
                </p>
                <p>Stake types:</p>
                <ul>
                    <li>stake: number // stake in mili format</li>
                    <li>
                        outcomeId: number //required when selectedTab is single
                    </li>
                    <li>toWinInput: number // not required</li>
                    <li>
                        eachWaySelected: boolean // required for eachWay
                        outcomes
                    </li>
                    <li>type: string // can be single, multiple, teaser</li>
                    <li>
                        systemType: string // required when selectedTab is
                        system. Can have one of the folowing values: single,
                        double, treble, fourfold, fivefold, sixfold, sevenfold,
                        eightfold, ninefold, tenfold, elevenfold, twelvefold,
                    </li>
                </ul>
                <CodeBlock
                    title={stakes.title}
                    expectedOutput={stakes.expectedOutput}
                    initialDisplayedCode={stakes.initialDisplayedCode}
                    moreCode={stakes.moreCode}
                />
            </TabPanel>
        </div>
    );
};

export default GetPotentialPayoutTabs;
